import { axiosApi } from "../../../api/dbAxios";

export const updateTeam = async (
  id: string | number,
  teamName: string,
  regIds: (string | number)[],
  requestsLimit?: number,
) => {
  const body = {
    regulators: regIds,
    name: teamName,
    id: id,
    requests_limit: requestsLimit,
  };
  try {
    const response = await axiosApi.patch(`/teams/${id}/`, body);
    return response.data;
  } catch (error) {
    console.error("Error updating Team:", error);
    return [];
  }
};
